import { CarrierName, Dtos } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { bondNumbersQueryKey } from "./useAdminFetchBondNumbers";

export const useAdminSetNextBondNumberBlock = () => {
	const queryClient = useQueryClient();
	const { put } = useRequest();

	const mutation = useMutation({
		mutationFn: async ({
			carrierName,
			block,
		}: {
			carrierName: CarrierName;
			block: Dtos.BondNumber.SetNextBlock.Request;
		}) => await put(`/v2/admin/surety/bond-numbers/${carrierName}/next`, block),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: bondNumbersQueryKey });
		},
	});

	return {
		setNextBlock: mutation.mutate,
		setNextBlockLoading: mutation.isPending,
		setNextBlockError: mutation.error,
		dismissSetNextBlockError: () => {
			mutation.reset();
		},
	};
};
